import { coreUtils } from "../../../assets/scripts/core-utils";

const coreScrollToTop = (function() {

    'use strict';

    const me = {};

    me.showHideScrollButton = () => {

        const scrollElement = $('.scroll-to-top');
        const scrollDistance = 1000;
        let showScrollButton = true;

        if ($(document).height() < 2000) {

            showScrollButton = false;

        }

        if (showScrollButton) {

            $(window).scrollTop() > scrollDistance ? scrollElement.removeClass('not-visible') : scrollElement.addClass('not-visible');

        }

    };

    me.scrollToTopButtonClick = (button) => {

        if (button === undefined) {

            button = $('.js-scroll-to-top');

        }

        button.on('click', (e) => {

            e.preventDefault();
            coreUtils.autoScroll(0, 1000);

        });

    };

    me.init = () => {

        $(window).on('scroll', () => {

           me.showHideScrollButton();

        });

        me.scrollToTopButtonClick();

    };

    return me;

}());

export { coreScrollToTop };
